import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import CheckoutModal from './CheckoutModal';

const CartDrawer = () => {
  const { items, isOpen, closeCart, removeItem, subtotal } = useCart();
  const [isCheckoutOpen, setIsCheckoutOpen] = useState(false);

  return (
    <>
      <div
        className={`fixed inset-0 bg-walnut-900/40 z-40 transition-opacity ${
          isOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        onClick={closeCart}
      />
      <div
        className={`fixed top-0 right-0 h-full w-full max-w-md bg-linen-50 z-50 shadow-lg flex flex-col transition-transform duration-200 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-linen-200">
          <h3 className="font-display text-xl font-semibold text-charcoal-900">Your cart</h3>
          <button onClick={closeCart} className="text-2xl text-walnut-500 hover:text-walnut-700" aria-label="Close cart">
            &times;
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {items.length === 0 ? (
            <div className="text-center text-walnut-400 py-16">Nothing in here yet.</div>
          ) : (
            items.map((line) => (
              <div key={line.key} className="flex gap-3 py-4 border-b border-linen-200">
                <div className="w-16 h-16 rounded-lg bg-linen-100 flex-shrink-0 overflow-hidden">
                  {line.imageUrl && (
                    <img src={line.imageUrl} alt={line.name} className="w-full h-full object-cover" />
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-charcoal-900 text-sm">{line.name}</div>
                  <div className="text-xs text-walnut-500">{line.meta}</div>
                  <div className="flex items-center justify-between mt-1">
                    <span className="font-bold text-copper-600">
                      {line.price != null ? `$${line.price}` : 'Price varies'}
                    </span>
                    <button
                      onClick={() => removeItem(line.key)}
                      className="text-xs text-red-600 underline"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>

        {items.length > 0 && (
          <div className="px-6 py-5 border-t border-linen-200">
            <div className="flex justify-between font-semibold text-charcoal-900 text-lg mb-4">
              <span>Subtotal</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
            <button
              onClick={() => setIsCheckoutOpen(true)}
              className="w-full bg-copper-500 text-linen-50 px-4 py-3 rounded-lg font-medium hover:bg-copper-600 transition-colors"
            >
              Checkout securely
            </button>
          </div>
        )}
      </div>

      {isCheckoutOpen && <CheckoutModal onClose={() => setIsCheckoutOpen(false)} />}
    </>
  );
};

export default CartDrawer;
